import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import CarouselDiv from "./mainLayout/CarouselDiv";
import QuickLinks from "./mainLayout/QuickLinks";
import Header from "./mainLayout/Header";
import SideBar from "./mainLayout/SideBar";
import Footer from "./mainLayout/Footer";

interface Props {
  window?: () => Window;
  children: React.ReactNode;
}

export default function Drawer(props: Props) {
  const { children } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  return (
    <Box sx={{ display: "flex", maxWidth: "100%" }}>
      <CssBaseline />
      <AppBar position="fixed" elevation={4} color={"primary"}>
        <Toolbar>
          <IconButton
            color="secondary"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: { xs: 0, sm: 2 } }}
          >
            <MenuIcon />
          </IconButton>
          <Header />
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <SideBar
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          isClosing={isClosing}
          setIsClosing={setIsClosing}
        />
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, width: "100%", minWidth: 0, maxWidth: "100%" }}
      >
        <CarouselDiv />
        <Box sx={{ width: "100%", minWidth: 0, maxWidth: "100%" }}>{children}</Box>
        <Footer />
        <QuickLinks />
      </Box>
    </Box>
  );
}
